
export const HumanIcon: React.FC = () => (
  <path
    fill="none"
    stroke="#fff8b8"
    strokeWidth="3"
    d="M0-40.71a11.13 11.13 0 01-11.12-11.13A11.13 11.13 0 010-63a11.13 11.13 0 0111.14 11.16A11.13 11.13 0 010-40.71zm-26.29 55a4.06 4.06 0 004 3.16 4.09 4.09 0 00.91-.1 4.06 4.06 0 003.05-4.86c-3-13.19-.55-23.35 2.75-30.32v74.71A6.1 6.1 0 00-9.51 63a6.09 6.09 0 006.09-6.09v-43.5h6.85v43.47a6.1 6.1 0 0012.19 0v-74.69c3.31 7 5.75 17.13 2.75 30.32a4.06 4.06 0 003.06 4.86 3.94 3.94 0 00.9.1 4.06 4.06 0 004-3.16 56.71 56.71 0 00.09-26 50.06 50.06 0 00-7.49-16.59A42.1 42.1 0 0013.1-35a6.55 6.55 0 00-4.72-1.61H-8.36a7 7 0 00-4.64 1.5c-.81.72-20.45 17.94-13.28 49.42z"
  />
);
